import { eapPurchasesForFeedbackQuery } from "@/api/sales";
import { queryClient } from "@/api/utils";
import { router } from "@/router";
import { seo } from "@/utils/seo";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/eap-review/")({
  beforeLoad: async ({ params, preload }) => {
    if (preload) {
      return;
    }
    const data = await queryClient.ensureQueryData(eapPurchasesForFeedbackQuery(params.supplierId));
    const purchase = data.purchases[0];
    if (!purchase) {
      return;
    }

    router.navigate({
      to: "/supplier/$supplierId/eap-review/$purchaseId",
      params: {
        supplierId: params.supplierId,
        purchaseId: purchase.id,
      },
      replace: true,
    });
  },
  head: () => ({
    meta: seo({ title: "Session Review" }),
  }),
});
